
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/summary",
      function () {
        return require("private-next-pages/shop/summary/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/summary"])
      });
    }
  